module.exports = __webpack_public_path__ + "static/minsoo.kim-114b538cbd554b8c3b4ec732a149854a.png";